/*eslint-disable */
import GroupInfo from './GroupInfo';

export default GroupInfo;
